import { callPromiseAssert } from "../../shared/util/callPromiseAssert";
import { viewJobNativeModule } from "./ViewJobNativeModule";

export function updateApplyStartCookie<T>(
  jobKey: string,
  sourceAbbreviation: string,
  domain: string,
): Promise<T> {
  return callPromiseAssert(
    viewJobNativeModule()?.updateApplyStartCookie<T>,
    "updateApplyStartCookie",
    jobKey,
    sourceAbbreviation,
    domain,
  );
}
